export default "__VITE_ASSET__RNM$EF1Y__"